import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import PresenterCameraCard from "../presentations/PresenterCameraCard";
interface DiapositiveData {
	id?:number;
	index:string;
	loop:string;
	name:string;
	slideUrl:string;
	timestamp:string
}
interface SlidesPresentationProps {
	publishedSlides: DiapositiveData[];
	currentSlideIndex: number;
	activeSlide: DiapositiveData | undefined;
	onClose: () => void;
	onImageError: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

const SlidesPresentation: React.FC<SlidesPresentationProps> = ({
	publishedSlides,
	currentSlideIndex,
	activeSlide,
	onClose,
	onImageError,
}) => {
	if (!activeSlide) {
		return null;
	}

	return (
		<div className="slidesPresentation" role="presentation">
			<div className="slidesPresentationContent">
				<div className="slidesPresentationFigure">
					<img
						src={activeSlide.slideUrl || "/assets/img/defaultImage.png"}
						alt={activeSlide.name || "slide"}
						onError={onImageError}
					/>
				</div>
			</div>
			<PresenterCameraCard />
		</div>
	);
};

export default SlidesPresentation;

